'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('../../../../../aviary-core/dist/cjs/index.cjs');
var Tooltip_web = require('../../atoms/Tooltip/Tooltip.web.cjs');
var QualityBadge_web_styles = require('./QualityBadge.web.styles.cjs');
var index = require('../../../../../../_virtual/index.cjs');

/**
 * A badge to display the quality of a product
 *
 * @scope: Web
 */ const QualityBadge = ({ type, tooltipContent, customCss, ...rest })=>{
    if (!type) return null;
    if (type === "Gold") {
        return /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
            tooltipContent: tooltipContent ? tooltipContent : "",
            isTooltipHidden: !tooltipContent,
            children: /*#__PURE__*/ jsxRuntime.jsx("img", {
                src: index.__exports.Gold,
                alt: "Emerson Quality Program: Gold.",
                css: [
                    QualityBadge_web_styles.qualityBadge,
                    customCss
                ],
                ...rest
            })
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
        tooltipContent: tooltipContent ? tooltipContent : "",
        isTooltipHidden: !tooltipContent,
        children: /*#__PURE__*/ jsxRuntime.jsx("img", {
            src: index.__exports.Silver,
            alt: "Emerson Quality Program: Silver.",
            css: [
                QualityBadge_web_styles.qualityBadge,
                customCss
            ],
            ...rest
        })
    });
};

exports.QualityBadge = QualityBadge;
//# sourceMappingURL=QualityBadge.web.cjs.map
